/**
 * Create System Setting context for custom hook
 */


import { createContext } from 'react'

const SystemSettingsContext = createContext({
  systemSettings: [],
  systemSettingsReady: false,
  getSystemSetting: () => {}
})

export default SystemSettingsContext
